// extracted by mini-css-extract-plugin
module.exports = {"bannerArrows":"BannerPortal_bannerArrows__25gtS"};